export default "__VITE_ASSET__BC4p87HI__"